import { atom, useAtom } from 'jotai';
import { OD_MAP_TYPES, type OdMapType } from '../../constants/odMap';

type UseOdMapConfig = {
  odMapType: OdMapType;
  setOdMapType: (value: OdMapType) => void;
  showsAllOd: boolean;
  setShowsAllOd: (value: boolean) => void;
};

const odMapTypeAtom = atom<OdMapType>(OD_MAP_TYPES.MESH_125M);

const showsAllOdAtom = atom<boolean>(false);

const useOdMapConfig = (): UseOdMapConfig => {
  const [odMapType, setOdMapType] = useAtom(odMapTypeAtom);
  const [showsAllOd, setShowsAllOd] = useAtom(showsAllOdAtom);

  return {
    odMapType: odMapType,
    setOdMapType: setOdMapType,
    showsAllOd: showsAllOd,
    setShowsAllOd: setShowsAllOd,
  };
};

export { useOdMapConfig };
